import React from "react";
import InfoC from "./InfoCards.module.css";
import { useNavigate } from "react-router-dom";

const InfoCards = () => {
  const navigate = useNavigate();
  return (
    <div className={InfoC.infoCards}>
      <div
        className={InfoC.card}
        onClick={() => {
          navigate("/dashboard/opportunities");
        }}
      >
        <h2>INVESTMENTS</h2>
        <p>
          Discover exclusive opportunities to grow your wealth by investing in
          premium sports assets.
        </p>
      </div>
      <div
        className={InfoC.card}
        onClick={() => {
          navigate("/dashboard/myPortfolio");
        }}
      >
        <h2>PORTFOLIO</h2>
        <p>
          Track your investments watch your contributions make a difference.
        </p>
      </div>
    </div>
  );
};

export default InfoCards;
